import useTitle from 'hooks/useTitle'

import CsvSheetCommonWrapper from '../Shared/CsvSheetCommon'

const LogisticsSheets = () => {
    useTitle('Logistics Sheets')
    return <CsvSheetCommonWrapper type={'logistics'} />
}

export default LogisticsSheets
